import {UI} from "../../../../../../stem-core/ui/UIBase";

import {ConfirmationModal} from "../../../../../ui/ConfirmationModal.jsx";
import {Messages} from "../../../../../Messages.js";
import {wrapInSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {Subscription} from "../../../../../../client/state/SubscriptionStore.js";
import {apiDeleteAddress, UserAddress} from "../../../../../../client/state/UserAddressStore.js";
import {autoredraw} from "../../../../../../stem-core/decorators/AutoRedraw";


@autoredraw(Subscription, UserAddress)
export class DeleteAddressModal extends ConfirmationModal {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.deleteAddressTitle,
            cancelLabel: Messages.close,
            confirmLabel: Messages.removeAddress,
            description: Messages.deleteAddressDescription(this.options.address.toString()),
            confirmAction: () => this.deleteAddress(),
            address: null,
        };
    }

    @wrapInSpinner
    async deleteAddress() {
        this.hide();
        await apiDeleteAddress(this.options.address.id);
    }
}
